import { Auslandsrisiko, Domaenenwert, Status } from '@ps20/bff-models';

export const AUSLANDS_RISIKOORT = 'Versicherungsort im Ausland';

export interface Auslandsrisikoort extends Risikoort {
  auslandsadresse?: string;
  auslandsrisiko?: Auslandsrisiko;
  isImmobilieImAusland?: boolean;
}

export interface Risikoort extends BasisAdresse {
  land: Domaenenwert;
  ortsteil?: string;
  hausnrzus?: string;
  changed?: boolean;
  status?: Status;
  zuerszone?: number;
}

export interface BasisAdresse {
  plz: string;
  ort: string;
  strasse: string;
  hausnummer: string;
  longtitude?: number;
  latitude?: number;
  noneValidated?: boolean;
  invalidAddress?: boolean;
}

export function isBasisAdresseExist(adresse: BasisAdresse): boolean {
  return !!adresse.plz && !!adresse.ort && !!adresse.hausnummer && !!adresse.strasse;
}

export const isAuslandsrisikoort = (risikoort: BasisAdresse): boolean => {
  const isAuslandsrisikoort =
    !!risikoort &&
    ('auslandsadresse' in risikoort ||
      'auslandsrisiko' in risikoort ||
      'isImmobilieImAusland' in risikoort);
  if (!isAuslandsrisikoort) {
    return false;
  }
  const auslandsrisikoort = risikoort as Auslandsrisikoort;
  return (
    [Auslandsrisiko.RISIKO_EUROPA, Auslandsrisiko.RISIKO_REST_DER_WELT].includes(
      auslandsrisikoort.auslandsrisiko,
    ) ||
    !!auslandsrisikoort.auslandsadresse ||
    auslandsrisikoort.isImmobilieImAusland
  );
};
